import { PROCESS } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export const Process = ({ serif = false }) => (
  <section data-testid="process-section" aria-labelledby="process-heading" className="section bg-white">
    <div className="container-site">
      <SectionHeading id="process" title="How It Works" accent={serif ? "Works" : undefined} sub="Four steps from first call to finished job. No surprises along the way." />
      <ol className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
        {PROCESS.map((p, i) => (
          <Reveal as="li" key={p.step} delay={i * 60} data-testid={`process-step-${i + 1}`} className="border-t-2 border-brand pt-6">
            <span className="text-sm font-semibold tracking-[0.08em] text-brand">STEP {p.step}</span>
            <h3 className="mt-3">{p.title}</h3>
            <p className="mt-3 text-base text-body">{p.text}</p>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
